import { Button } from '~/components/ui/button';
import { Badge } from '~/components/ui/badge';
import { cn } from '~/lib/utils';
import type { IFormWithCount } from '~/types';

interface IFormFilterTabsProps {
  forms: IFormWithCount[];
  selectedFormId: string | undefined;
  onSelect: (formId: string | undefined) => void;
}

export const FormFilterTabs = ({ forms, selectedFormId, onSelect }: IFormFilterTabsProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        variant={selectedFormId === undefined ? 'default' : 'outline'}
        size="sm"
        className="h-8"
        onClick={() => onSelect(undefined)}
      >
        All Forms
        <Badge
          variant="secondary"
          className={cn(
            'ml-1.5 px-1.5 text-xs',
            selectedFormId === undefined && 'bg-primary-foreground/20 text-primary-foreground',
          )}
        >
          {forms.reduce((sum, f) => sum + f.submissionCount, 0)}
        </Badge>
      </Button>
      {forms.map((form) => (
        <Button
          key={form.id}
          variant={selectedFormId === form.id ? 'default' : 'outline'}
          size="sm"
          className="h-8"
          onClick={() => onSelect(form.id)}
        >
          {form.name}
          <Badge
            variant="secondary"
            className={cn(
              'ml-1.5 px-1.5 text-xs',
              selectedFormId === form.id && 'bg-primary-foreground/20 text-primary-foreground',
            )}
          >
            {form.submissionCount}
          </Badge>
        </Button>
      ))}
    </div>
  );
};
